/* eslint no-unused-vars: 0 */

import React from 'react';

class SiteSearchCategoryResults extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {this.props.categories.length > 0 ? <h3>Categories</h3> : ''}
        <ul>
          {this.props.categories.map((c, index) => {
            return (
              <li
                key={index}
                dangerouslySetInnerHTML={{ __html: c.highlighted_name }}
                onClick={e => {
                  if (window.dataLayer) {
                    window.dataLayer.push({
                      event: 'AutoSearchCategory',
                      category: c.highlighted_name.replace(/(<([^>]+)>)/gi, ''),
                      searchUsed: this.props.query,
                      position: index + 1,
                    });
                  }
                  this.props.viewLink(c.url);
                  e.stopPropagation();
                }}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

export default SiteSearchCategoryResults;
